import { FEATURE_FLAGS, isProduction } from "../../shared/Env";
import { useTokenContext } from "../providers/TokenProvider";

export default function useExperimentOverridesEnabled() {
  const { getTokens } = useTokenContext();
  return (
    (!!getTokens()?.decodedToken?.is_admin || !isProduction) &&
    !!FEATURE_FLAGS.EXPERIMENT_OVERRIDE
  );
}
